/**
 * PUT /api/profile answers a failed rule with a machine code in `error`
 * ('invalid_phone', 'unknown_specialty') rather than a sentence, so every
 * client must translate it. Without this mapping the user sees the raw code
 * or a generic "could not save" and has no idea which field to fix.
 *
 * Returns the translation key, or null for anything else (the caller keeps
 * its own generic fallback).
 */
export function profileErrorMessageKey(code: unknown): string | null {
  if (code === 'invalid_phone') return 'phone.invalid'
  if (code === 'unknown_specialty') return 'profile.unknownSpecialty'
  return null
}
